// extracted by mini-css-extract-plugin
export default {"PaginationInformation":"_PaginationInformation--lfxYT","HiddenPaginationInformation":"_HiddenPaginationInformation--jkXES"};